import {
  ADD_UPDATE_LOZIER_STORE_FAILURE,
  ADD_UPDATE_LOZIER_STORE_REQUEST,
  ADD_UPDATE_LOZIER_STORE_SUCCESS,
  FETCH_LOZIER_STORE_LIST_FAILURE,
  FETCH_LOZIER_STORE_LIST_REQUEST,
  FETCH_LOZIER_STORE_LIST_SUCCESS,
} from "./actionTypes";
import { LozierStoreList } from "./types";

export const fetchLozierStoreListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  }
) => ({
  type: FETCH_LOZIER_STORE_LIST_REQUEST,
  url,
  payload,
});

export const fetchLozierStoreListSuccess = (
  lozierStoreList: LozierStoreList[],
  totalCount: number = 0
) => ({
  type: FETCH_LOZIER_STORE_LIST_SUCCESS,
  payload: { lozierStoreList, totalCount },
});

export const fetchLozierStoreListFailure = (error: string) => ({
  type: FETCH_LOZIER_STORE_LIST_FAILURE,
  payload: error,
});

export const addUpdateLozierStoreRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_LOZIER_STORE_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateLozierStoreSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_LOZIER_STORE_SUCCESS,
  payload: { successMessage },
});

export const addUpdateLozierStoreFailure = (error: string) => ({
  type: ADD_UPDATE_LOZIER_STORE_FAILURE,
  payload: error,
});
